import { DatePicker, Form, Input, Modal, Select } from "antd";
import type { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import { useCreateAbsence } from "../hooks/useAbsences";
import { ABSENCE_TYPE_VALUES, type AbsenceType } from "../types";

const { RangePicker } = DatePicker;

interface FormValues {
	employeeId: string;
	type: AbsenceType;
	range: [Dayjs, Dayjs];
	reason?: string;
}

interface Props {
	open: boolean;
	onClose: () => void;
	employeeOptions: { value: string; label: string }[];
	/** Server tomonda qidiruv — `q` parametri (`useAbsenceEmployeeOptions`). */
	onEmployeeSearch: (value: string) => void;
}

export function AbsenceCreateModal({ open, onClose, employeeOptions, onEmployeeSearch }: Props) {
	const { t } = useTranslation("absences");
	const [form] = Form.useForm<FormValues>();
	const create = useCreateAbsence();

	async function handleOk() {
		const values = await form.validateFields();

		await create.mutateAsync({
			employeeId: values.employeeId,
			type: values.type,
			// ⚠️ `YYYY-MM-DD` — `date` ustuni, zonasiz kalendar sanasi.
			// `toISOString()` QILINMAYDI: u UTC ga o'girib, mahalliy
			// yarim tundan oldingi sanani BIR KUN ORQAGA surardi.
			dateFrom: values.range[0].format("YYYY-MM-DD"),
			dateTo: values.range[1].format("YYYY-MM-DD"),
			reason: values.reason,
		});

		form.resetFields();
		onClose();
	}

	return (
		<Modal
			open={open}
			title={t("createModal.title")}
			okText={t("createModal.okText")}
			cancelText={t("createModal.cancelText")}
			confirmLoading={create.isPending}
			onOk={handleOk}
			onCancel={onClose}
		>
			<Form form={form} layout="vertical">
				<Form.Item
					name="employeeId"
					label={t("createModal.employeeLabel")}
					rules={[{ required: true, message: t("createModal.employeeRequired") }]}
				>
					{/*
					  ⚠️ `filterOption={false}` — qidiruv SERVERDA (`q`
					  parametri). Standart klient filtri bilan birga
					  ishlatilsa, server qaytargan 100 tadan yana klient
					  filtri o'tib, foydalanuvchi kiritgan matn ro'yxatda
					  yo'q bo'lsa bo'sh natija ko'rsatardi.
					*/}
					<Select
						showSearch
						filterOption={false}
						options={employeeOptions}
						onSearch={onEmployeeSearch}
					/>
				</Form.Item>
				<Form.Item
					name="type"
					label={t("createModal.typeLabel")}
					rules={[{ required: true, message: t("createModal.typeRequired") }]}
				>
					<Select
						options={ABSENCE_TYPE_VALUES.map((value) => ({
							value,
							label: t(`type.${value}`),
						}))}
					/>
				</Form.Item>
				<Form.Item
					name="range"
					label={t("createModal.rangeLabel")}
					rules={[{ required: true, message: t("createModal.rangeRequired") }]}
				>
					<RangePicker style={{ width: "100%" }} />
				</Form.Item>
				<Form.Item name="reason" label={t("createModal.reasonLabel")}>
					<Input.TextArea rows={3} maxLength={2000} />
				</Form.Item>
			</Form>
		</Modal>
	);
}
